import { Link } from 'react-router-dom';
import Wordmark from '../components/Wordmark';
import Eyebrow from '../components/Eyebrow';
import Button from '../components/Button';
import { CONTACT_EMAIL } from '../components/ContactLine';
import { useForceLight } from '../lib/theme';

export default function Landing() {
  useForceLight();
  return (
    <main className="min-h-screen bg-page text-fg flex flex-col">
      <header className="px-6 md:px-12 py-6 flex items-center">
        <Wordmark size="md" />
      </header>

      <section className="flex-1 flex items-center px-6 md:px-12">
        <div className="max-w-4xl mx-auto w-full">
          <div
            className="animate-rise-subtle"
            style={{ animationDelay: '0ms' }}
          >
            <Eyebrow accent>// 01 — SCRIPTS</Eyebrow>
          </div>

          <h1
            className="font-display font-bold text-fg mt-6 leading-[0.95] tracking-[-0.03em] animate-rise"
            style={{
              fontSize: 'clamp(3rem, 8vw, 6.5rem)',
              animationDelay: '120ms',
            }}
          >
            Scripts that feel
            <br />
            like the work.
          </h1>

          <p
            className="text-muted mt-8 max-w-xl text-lg leading-[1.55] animate-rise-subtle"
            style={{ animationDelay: '240ms' }}
          >
            A calm place for Sheahan Studios clients to review, comment and
            approve a script, without ever opening a Google Doc.
          </p>

          <div
            className="mt-10 flex items-center gap-4 animate-rise-subtle"
            style={{ animationDelay: '360ms' }}
          >
            <Link to="/admin">
              <Button variant="primary" glow>
                Sign in
                <span aria-hidden>→</span>
              </Button>
            </Link>
          </div>

          <p
            className="text-muted text-[14px] leading-[1.55] mt-10 max-w-xl animate-rise-subtle"
            style={{ animationDelay: '480ms' }}
          >
            Reviewing a script? Everything lives at the private link Henry sent you. Can’t find
            it? Email him at{' '}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-accent underline underline-offset-2 hover:opacity-80 transition-opacity"
            >
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </div>
      </section>

      <footer className="px-6 md:px-12 py-6 flex items-center justify-between text-faint">
        <span className="font-mono text-[11px] uppercase tracking-[0.12em]">
          Melbourne · 2026 · Confidential
        </span>
        <span className="font-mono text-[11px] uppercase tracking-[0.12em]">
          scripts.sheahanstudios
        </span>
      </footer>
    </main>
  );
}
